export interface IRow {
  [index: string]: any;
}

export interface ITableColumn {
  Name: string;
  Header: string;
  Sortable: boolean;
  Type: number;
  TypeName: string;
  Ordinal: number;
  Width: number;
  IsSystemColumn: boolean;
  type: number;
  IsExpandableRow?: boolean;
  Exportable: boolean;
  Visible: boolean;
}



export interface ITable {
  Columns: ITableColumn[];
  Rows: IRow[];
  hasTotalRow?: boolean;
}


export const emptyTable: ITable = {
  Columns: [],
  Rows: []
}

export interface IResizedColumn {
  FieldName: string;
  WidthChange: number;
}
